import { render, staticRenderFns } from "./realtimeMenu.vue?vue&type=template&id=215f6f3e&scoped=true"
import script from "./realtimeMenu.vue?vue&type=script&lang=js"
export * from "./realtimeMenu.vue?vue&type=script&lang=js"
import style0 from "./realtimeMenu.vue?vue&type=style&index=0&id=215f6f3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215f6f3e",
  null
  
)

export default component.exports